import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const Location = () => import("@/views/Dashboard/Location.vue");
const Container = () => import("@/components/layouts/Container.vue");
const Comercio = () => import("@/views/Dashboard/Comercio.vue");
const Home = () => import("@/views/Home.vue");
const Cart = () => import("@/views/Dashboard/Cart.vue");
const Pedido = () => import("@/views/Dashboard/PedidoEspecifico.vue");
const Menu = () => import("@/views/Dashboard/Menu.vue");
const Food = () => import("@/views/Dashboard/food.vue");
const About = () => import("@/views/About.vue");
const Scan = () => import("@/views/Dashboard/Scan.vue");
const Login = () => import("@/views/Login/Login.vue");
const Account = () => import("@/views/Dashboard/Account.vue");
const FinalizeOrder = () => import("@/views/Dashboard/FinalizeOrder.vue");


const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: "/home",
    name: "start",
    component: Container,
    children: [
      {
      path: '',
      name: 'Home',
      component: Home
    },
    {
      path: 'carrito',
      name: 'carrito',
      component: Cart
    },
    {
      path: 'orden',
      name: 'finalizar',
      component: FinalizeOrder
    },
    {
      path: ':contenido/food',
      name: 'food',
      component: Food
    },
    {
      path: 'comercio',
      name: 'comercio',
      component: Comercio
    },
    {
      path: 'pedido',
      name: 'pedido',
      component: Pedido,
    },
    {
      path: 'about',
      name: 'About',
      component: About,
      meta: { requiresAuth: true }
    },
    {
      path: 'location',
      name: 'Location',
      component: Location,
      meta: { requiresAuth: true }
    },
    {
      path: ':contenido',
      name: 'contenido',
      component: Menu
    },
    {
      path: 'scan',
      name: 'scan',
      component: Scan
    },
    {
      path: 'login',
      name: 'login',
      component: Login
    },
    {
      path: 'account',
      name: 'account',
      component: Account,
      meta: { requiresAuth: true }
    }
  ]
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const user_name = localStorage.getItem('user_id');

  if (requiresAuth && !user_name) {
    return { name: 'login' };
  }
})

export default router
